import React, { useContext, useEffect, useState } from "react";
import partImage from "../../assets/thumb.png";
import settingw from "../../assets/setting-white.svg";
import orderIcon from "../../assets/orderIcon.svg";
import chatico from "../../assets/chat.svg";
import shippingIcon from "../../assets/shippingIcon.svg";
import tickgreen from "../../assets/tick-green.svg";
import tickwhite from "../../assets/tick-white.svg";
import downloadImage from "../../assets/download.svg";
import downloadImageBlue from "../../assets/download.png";
import qualityDocIcon from "../../assets/qc-document.svg";
import consignmentPhotoIcon from "../../assets/dashboard.svg";
import starsIcon from "../../assets/stars.svg";
import starsIconGrey from "../../assets/stars-grey.svg";
import downArrowIcon from "../../assets/downArrow.svg";
import qrCodeIcon from "../../assets/qr-code-icon.svg";
import upArrowIcon from "../../assets/upArrow.svg";
import deleteImageEnabled from "../../assets/blackdelete.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Modal as AntModal } from "antd";
// import { useIntercom } from "react-use-intercom";
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  Tabs,
  Tab,
  FormControl,
} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import { MAX_FILE_LIMIT, processType } from "../../utils/constant";
import {
  getOrderByPoRefId,
  handleAcceptPO,
  updateShippingInformation,
  updateDeliveryInformation,
  updateQualityDocsFromSupplier,
  getIssuesForPO,
  updateExpectedShippingDates,
  getEightXAddress,
  downloadPurchaseOrderPdf,
  getBillsByPoId,
  createBillForPurchaseOrder,
  getOrderByPoId,
} from "../../utils/actions/userActions";
import moment from "moment";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import ChatButton from "../../component/Chat/ChatButton";
import Chat from "../../component/Chat/index";
import { ChatRefContext } from "../../context/chatRef.context";
import {
  currencyFormatter,
  downloadFileFromS3,
  extractURLAndEncodedFilename,
  numberInputOnWheelPreventChange,
  validateUser,
} from "../../utils/helper";
import backImg from "../../assets/back.svg";
import HoverInfo from "../../component/HoverInfo/HoverInfo";
import CurrencyFormat from "../../component/CurrencyFormat";
import { Loading } from "../../component/Loading";
import editIcon from "../../assets/edit.svg";
import BillDisplayModal from "../../component/BillDisplayModal";
import ConsignmentPhotoViewer from "../../component/ConsignmentPhotoViewer";
import { DeleteIcon, DownloadIcon, EditIcon } from "../../component/icons";
import MetaDataCncComponent from "../../component/MetaDataComponents/MetaDataCncComponent";
import MetaDataThreeDComponent from "../../component/MetaDataComponents/MetaDataThreeDComponent";
import { getAllMaterialsList, getAllTechnology, getPresignedUrlForFile } from "../../helperApi/helperApi";
import ThreeDViewerComponent from "../../component/ThreeDViewerComponent/ThreeDViewerComponent";
import FileName from "../../component/FileName";
import PDFModalViewer from "../../component/PDFViewerModal/PDFModalViewer";
import WithDragAndDrop from "../../component/DragAndDrop/DragAndDropButton";
import DimensionsDisplay from "../../component/DimensionDisplay/DimensionDisplay";

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const OrderDetails = () => {
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  let decode;
  const { setSelectedChatRefId } = useContext(ChatRefContext);
  const [order, setOrder] = useState(null);
  const [expanded, setExpanded] = React.useState(false);
  const [isValidUser, setIsValidUser] = useState(true);
  const { search } = window.location;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  console.log("Id ::", id);
  const [qualityDocObject, setQualityDocObject] = useState({
    name: "",
    file: null,
  });
  const [allIssuesForOrder, setAllIssuesForOrder] = useState([]);
  const [isInvoiceModalVisible, setInvoiceModalVisible] = useState(true);
  const [orderIssue, setOrderIssue] = useState([]);
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [key, setKey] = useState(0);
  const [showExpectedDateModal, setShowExpectedDateModal] = useState(false);
  const [isAcceptPO, setIsAcceptPO] = useState(false);
  const [expectedShippingDateSelected, setExpectedShippingDateSelected] =
    useState(null);
  const [esdChangeReason, setEsdChangeReason] = useState("");
  const [billsForPurchaseOrder, setBillsForPurchaseOrder] = useState([]);
  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);
  const [billPartsData, setBillPartsData] = useState({});
  const [availableQtyArr, setAvailableQtyArr] = useState({});
  const [billTotalAmount, setBillTotalAmount] = useState(0);
  const [billDocument, setBillDocument] = useState(null);
  const [supplierBillNumber, setSupplierBillNumber] = useState("");
  const [billConsignmentPhotos, setBillConsignmentPhotos] = useState([]);
  const [billQualityDocuments, setBillQualityDocuments] = useState([]);
  const [billShippingDate, setBillShippingDate] = useState(null);
  const [billShippingCarrier, setBillShippingCarrier] = useState("");
  const [billTrackingNumber, setBillTrackingNumber] = useState("");
  const [billToShow, setBillToShow] = useState(null);
  const [isNoConsignments, setIsNoConsignments] = useState(false);
  const [isNoQCDoc, setIsNoQCDoc] = useState(false);
  const [isShowBill, setIsShowBill] = useState(false);
  let userId = localStorage.getItem("_id");
  let email = localStorage.getItem("email");

  const [pdfModalInfo, setPdfModalInfo] = useState({
    show: false,
    fileName: '',
    pdfUrl: ''
  });

  const [allData, setAllData] = useState([]);
  const [masterThreeDTechnologyData, setMasterThreeDTechnologyData] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getAllTechnology();
        if (data?.success) {
          setMasterThreeDTechnologyData(data?.data);
        }
      } catch (error) {
        console.error(error);
      }
      finally {
      }
    })()

  }, []);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getAllMaterialsList();
        setAllData(data);
      } catch (error) {
        throw new Error("Unable To fetch All Material Data ");
      }
      finally {
      }
    })()

  }, []);
  console.log("Bills For Po :", billsForPurchaseOrder);
  useEffect(() => {
    let billForPoArr = [...billsForPurchaseOrder];
    billForPoArr = billForPoArr.filter((item) => !item.isRejected);
    let localAvailableQtyData = {};
    order?.supplierRfqOfferId?.partsData?.forEach((lineItem) => {
      localAvailableQtyData[lineItem._id] = lineItem.qty;
    });
    if (billForPoArr.length > 0) {
      billForPoArr.forEach((item) => {
        item?.partsData?.forEach((lineItem) => {
          localAvailableQtyData[lineItem.partItemId] =
            localAvailableQtyData[lineItem.partItemId] - lineItem?.shippedQty;
        });
      });
    };
    setAvailableQtyArr(localAvailableQtyData);
  }, [billsForPurchaseOrder]);

  const fetchSecondaryData = async (orderId) => {
    try {
      getBillsByPoId(token, orderId)
        .then((response) => setBillsForPurchaseOrder(response.data))
        .catch((err) => console.log("Error fetching invoices."));
    } catch (error) {
    }
  };

  const handleIssueModalClose = () => {
    setShowIssueModal(false);
  };



  const showDrawer = () => {
    setOpen(true);
    let id = order?.pORefId;

    if (id.startsWith('S')) {
      if (id[1] == '-') {
        id = id.slice(2)
      }
      else {
        id = id.slice(1)
      }
    }
    console.log("Setting id ::", id);
    setSelectedChatRefId(id)

    setSelectedChatRefId(id);
  };

  const onClose = () => {
    setOpen(false);
    setSelectedChatRefId(null);
  };
  const canRemoveImage = () => true;

  const handleRemoveImage = (index) => {
    setBillConsignmentPhotos((pre) => {
      let localConsignmentPhotos = [...pre];
      localConsignmentPhotos.splice(index, 1);
      return [...localConsignmentPhotos];
    });

  }

  function isUrlValid(str) {
    str = str ? str : "";
    if (!str.startsWith("http://") && !str.startsWith("https://")) {
      str = "http://" + str;
    }
    var a = document.createElement("a");
    a.href = str;
    return a.host && a.host != window.location.host;
  }

  const fetchData = async () => {
    try {
      setLoading(true);
      const orderResponse = await getOrderByPoId(id, token);
      if (orderResponse.status) {
        setOrder(orderResponse.data);
      } else {
        toast.error(
          "Order data not found.Please contact us at info@dainst.com to resolve the issue."
        );
        navigate("/my-orders");
        return;
      }

      fetchSecondaryData(orderResponse.data._id);

      let allIssue = await getIssuesForPO(token);
      let localOrderIssue = [];
      if (allIssue.data.length > 0) {
        allIssue.data.map((item, i) => {
          if (item?.orderId === orderResponse.data._id) {
            localOrderIssue.push(item);
          }
        });
      }

      if (localOrderIssue.length > 0) {
        setAllIssuesForOrder(localOrderIssue);
        setOrderIssue(localOrderIssue[localOrderIssue.length - 1]);
        setKey(localOrderIssue.length - 1);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("err1", err);
      toast.error(err.message);
    }
  };

  const handleAcceptPOClick = async () => {
    setShowExpectedDateModal(true);
    setIsAcceptPO(true);
  };

  const handleDeliveryInformationUpdate = async (e) => {
    try {
      if (order.status == "Cancelled" || order.status == "Closed") {
        toast.error(`Order is already ${order.status.toLowerCase()}`);
        return;
      }

      if (moment(order.shippedDate).isAfter(moment(e.target.value))) {
        toast.error("Delivery date cannot be before shipping date.");
        return;
      }



      let data = {
        orderId: order._id,
        deliveryDate: e.target.value,
        existingStatus: order.status,
      };

      const updateDeliveryResponse = await updateDeliveryInformation(
        token,
        data
      );
      if (updateDeliveryResponse.data.status) {
        setOrder({
          ...order,
          deliveryDate: updateDeliveryResponse?.data?.data?.deliveryDate,
        });
        toast.success("Delivery date updated successfully");
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong while updating delivery information");
    }
  };

  const handleShippingInformationUpdate = async () => {
    try {
      if (order.status == "Cancelled" || order.status == "Closed") {
        toast.error(`Order is already ${order.status.toLowerCase()}`);
        return;
      }

      if (!order.shippingCarrier || !order.deliveryTrackingLink) {
        toast.error("Shipping Carrier and Tracking Number are required field");
        return;
      }

      let shippingData = {
        shippingCarrier: order.shippingCarrier,
        deliveryTrackingLink: order.deliveryTrackingLink,
        orderId: order._id,
      };

      await updateShippingInformation(token, shippingData);

      toast.success("Shipping information updated successfully");
    } catch (err) {
      console.log("err", err);
      return;
    }
  };

  const handleQualityDocsUpdate = async () => {
    try {
      if (order.status == "Cancelled" || order.status == "Closed") {
        toast.error(`Order is already ${order.status.toLowerCase()}`);
        return;
      }

      if (!qualityDocObject.name || !qualityDocObject.file) {
        toast.error("Document name and file are required.");
        return;
      }

      let localQualityDoc = [...order.qualityDocuments];
      localQualityDoc.push(qualityDocObject);

      let formData = new FormData();
      localQualityDoc.forEach((val, i) => {
        formData.append("fileToUpload", val.file);
      });
      formData.append("qualityDoc", JSON.stringify(localQualityDoc));
      formData.append("orderId", order._id);

      const qualityDocResponse = await updateQualityDocsFromSupplier(
        token,
        formData
      );

      if (qualityDocResponse.data.status) {
        setOrder({ ...qualityDocResponse.data.data });
        toast.success("Quality document uploaded successfully.");
        setQualityDocObject({ name: null, file: null });
      }
    } catch (err) {
      console.log("err", err);
      return;
    }
  };

  const handleQualityDocsUpload = () => {
    if (!qualityDocObject.name || !qualityDocObject.file) {
      toast.error("Document name and file are required.");
      return;
    }



    setBillQualityDocuments([...billQualityDocuments, qualityDocObject]);
    setQualityDocObject({
      name: "",
      file: null,
    });
  };

  const handleQualityDocumentDelete = (index) => {
    // Create a new array with the item at the specified index removed
    const updatedDocuments = billQualityDocuments.filter((_, i) => i !== index);

    // Update the state with the new array
    setBillQualityDocuments(updatedDocuments);
  };

  const handleConsignmentPhotosUpload = (e) => {
    let filesForCheck = Array.from(e.target.files);
    let isAllFilesValid = true;
    filesForCheck.forEach((file) => {
      if (file.size > MAX_FILE_LIMIT) {
        isAllFilesValid = false;
      }
    });

    if (!isAllFilesValid) {
      toast.error("File size should be less than 100 MB");
      return;
    }

    let files = e.target.files;
    setBillConsignmentPhotos([...billConsignmentPhotos, ...files]);
  };

  const handleConsignmentFileDelete = async (index) => {
    let localConsignmentPhotos = [...billConsignmentPhotos];
    localConsignmentPhotos.splice(index, 1);
    setBillConsignmentPhotos([...localConsignmentPhotos]);
  };

  const handleQualityDocDelete = async (index) => {
    let localQualityDocuments = [...order.qualityDocuments];
    localQualityDocuments.splice(index, 1);

    let formData = new FormData();
    localQualityDocuments.forEach((val, i) => {
      formData.append("fileToUpload", val.file);
    });
    formData.append("qualityDoc", JSON.stringify(localQualityDocuments));
    formData.append("orderId", order._id);
    const qualityDocResponse = await updateQualityDocsFromSupplier(
      token,
      formData
    );
    if (qualityDocResponse.data.status) {
      setOrder({ ...qualityDocResponse.data.data });
      toast.success("Quality document deleted successfully.");
    }
  };
  let getFileExtension = (filename) => {
    return filename?.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
  };

  const handleShowSelectedIssue = (key) => {
    setOrderIssue(allIssuesForOrder[key]);
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  useEffect(() => {
    if (!token) {
      navigate("/");
    } else {
      decode = jwt_decode(token);
      if (!decode) {
        navigate("/");
        toast.error("Invalid Token found!");
      } else if (decode) {
        if (decode.userType == "user") {
          let isLoggedInUser = validateUser();
          if (isLoggedInUser) {
            if (id) {
              fetchData();
            }
          }
        } else if (decode.userType == "admin") {
          navigate("/admin");
        } else {
          navigate("/");
        }
      }
    }
  }, []);

  const handleProceedAcceptPOClick = async () => {
    try {
      if (!expectedShippingDateSelected) {
        toast.error("Please selected expected shipping date.");
        return;
      }

      let expectedShippingDateValue = null;
      if (
        !(
          moment(expectedShippingDateSelected).format("DD MMM YYYY") ==
          moment(Date.now())
            .add(order?.supplierRfqOfferId?.leadTime, "days")
            .format("DD MMM YYYY")
        )
      ) {
        if (!esdChangeReason) {
          toast.error(
            "Please enter reason to change the Expected Shipping date."
          );
          return;
        }
        expectedShippingDateValue = expectedShippingDateSelected;
      }

      let data = {
        orderId: order?._id,
        expectedShippingDate: expectedShippingDateValue,
        reasonToChange: esdChangeReason,
      };
      const response = await handleAcceptPO(token, data);
      if (response.data.status) {
        setOrder(response.data.data);
        setIsAcceptPO(false);
        setShowExpectedDateModal(false);
        setExpectedShippingDateSelected(null);
        setEsdChangeReason("");
        toast.success(response.data.message);
      } else {
        toast.error("Something went wrong while accepting PO");
      }
    } catch (err) {
      console.log("err", err.message);
      return;
    }
  };
  useEffect(() => {
    if (order?.supplierRfqOfferId?.leadTime !== undefined) {
      const baseDate = order?.poAcceptanceDate
        ? moment(order.poAcceptanceDate)
        : moment();

      const calculatedDate = baseDate
        .add(order.supplierRfqOfferId.leadTime, "days")
        .format("YYYY-MM-DD"); // format for input[type="date"]

      setExpectedShippingDateSelected(calculatedDate);
    }
  }, [order]);



  const handleClose = () => {
    setShowExpectedDateModal(false);
    setEsdChangeReason("");
  };

  const handleUpdateExpectedShippingDates = async () => {
    try {
      if (!expectedShippingDateSelected) {
        toast.error("Please selected expected shipping date.");
        return;
      }
      if (!esdChangeReason) {
        toast.error(
          "Please enter reason to change the Expected Shipping date."
        );
        return;
      }

      let data = {
        expectedShippingDate: expectedShippingDateSelected,
        id: order._id,
        reasonToChange: esdChangeReason,
      };
      const response = await updateExpectedShippingDates(token, data);
      if (response.status) {
        toast.success("Expected Shipping date updated successfully");
        setShowExpectedDateModal(false);
        setExpectedShippingDateSelected(null);
        setEsdChangeReason("");
        setOrder({
          ...order,
          expectedShippingDates: response.data.expectedShippingDates,
        });
      }
    } catch (err) { }
  };

  const handlePODownloadClick = async () => {
    setLoading(true);
    try {

      let data = {
        orderId: order?._id,
      };

      const response = await downloadPurchaseOrderPdf(data, token);
      console.log("Response ::", response);
      const { signedUrl, success } = response.data;
      console.log('Signed url ::', signedUrl);
      console.log('Success ::', success);
      if (success) {
        setPdfModalInfo({
          show: true,
          fileName: `Purchase_Order_${order?.purchaseOrderNumber}.pdf`,
          pdfUrl: signedUrl
        });
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("err", err);
      toast.error(err.message);
    }
  };

  const handleCreateNewInvoiceClick = () => {
    let isAllInvoiced = true;
    let availableQtyValuesArr = Object.values(availableQtyArr);
    availableQtyValuesArr.forEach((item) => {
      if (item > 0) {
        isAllInvoiced = false;
      }
    });

    if (!isAllInvoiced) {
      setShowCreateInvoiceModal(true);
    } else {
      toast.error("All items for this order are already invoiced");
    }
  };

  const closeCreateInvoiceModal = () => {
    setShowCreateInvoiceModal(false);
    setBillDocument(null);
    setSupplierBillNumber("");
  };

  const handeBillItemChange = (event, lineId) => {
    const value = event.target.value;
    const isEmpty = value === "";
    const isNaturalNumber = /^[1-9][0-9]*$/.test(value);
    if (!isEmpty && !isNaturalNumber) {
      return;
    }

    let localBillPartsData = { ...billPartsData };
    if (availableQtyArr[lineId] < parseInt(event.target.value)) {
      toast.error(
        "The invoice quantity cannot be more than order item quantity"
      );
      localBillPartsData[lineId] = 0;
    } else {
      localBillPartsData[lineId] = event.target.value;
    }

    setBillPartsData(localBillPartsData);
    let localBilTotalAmount = 0;
    order?.supplierRfqOfferId?.partsData.forEach((item) => {
      localBilTotalAmount =
        localBilTotalAmount + (localBillPartsData[item._id] || 0) * item.price;
    });
    setBillTotalAmount(localBilTotalAmount);
  };

  // console.log("Data :",order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess);
  // console.log("Order :",order);
  const handleCreateBill = async () => {
    try {
      if (!order?.purchaseOrderNumber) {
        toast.error(
          "Purchase order number is not updated.Please contact admin"
        );
        return;
      }

      if (billTotalAmount <= 0) {
        toast.error(
          "Please enter valid shipping details for parts. Bill amount cannot be zero."
        );
        return;
      }

      if (!billDocument) {
        toast.error("Please upload invoice document");
        return;
      }

      if (!supplierBillNumber) {
        toast.error("Please enter invoice number");
        return;
      }

      if (!billShippingDate) {
        toast.error("Please enter shipping Date.");
        return;
      }

      if (!supplierBillNumber) {
        toast.error("Please enter invoice number");
        return;
      }

      if (!isNoConsignments && billConsignmentPhotos.length == 0) {
        toast.error("Atleast one consignment photo is required");
        return;
      }

      if (!isNoQCDoc && billQualityDocuments.length == 0) {
        toast.error("Atleast one quality document is required");
        return;
      }

      let userResponse = await new Promise((resolve) => {
        AntModal.confirm({
          title: 'Send for Approval',
          content: 'Are you sure you want to send these details for approval?',
          okText: 'Yes, Send',
          cancelText: 'No',
          onOk: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
      if (!userResponse) {
        return;
      }

      let formData = new FormData();
      formData.append("billPartsData", JSON.stringify(billPartsData));
      formData.append("billTotalAmount", billTotalAmount);
      formData.append("supplierBillNumber", supplierBillNumber);
      formData.append("poId", order?._id);
      formData.append("pORefId", order.pORefId);
      formData.append("supplierId", order.supplierId._id);
      formData.append("shippedDate", billShippingDate);
      formData.append("deliveryTrackingLink", billTrackingNumber);
      formData.append("shippingCarrier", billShippingCarrier);
      formData.append("isNoQCDocChecked", isNoQCDoc);
      formData.append("isNoConsignmentsChecked", isNoConsignments);
      formData.append(
        "billQualityDocumentsData",
        JSON.stringify(billQualityDocuments)
      );
      formData.append("billDocument", billDocument);
      billConsignmentPhotos.forEach((photo) => {
        formData.append("billConsigmentPhotos", photo);
      });
      billQualityDocuments.forEach((doc) => {
        formData.append("billQualityDocuments", doc.file);
      });
      setLoading(true);
      const createBillResponse = await createBillForPurchaseOrder(
        token,
        formData
      );

      if (createBillResponse.status) {
        toast.success("Bill created successfully and sent for approval.");
        setShowCreateInvoiceModal(false);
        setBillTotalAmount(0);
        setBillDocument(null);
        setSupplierBillNumber("");
        setBillConsignmentPhotos([]);
        setBillQualityDocuments([]);
        setBillPartsData({});
        let localBillsForPO = [...billsForPurchaseOrder];
        localBillsForPO.push(createBillResponse.data);
        setBillsForPurchaseOrder(localBillsForPO);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error creating", err);
      if (err?.response?.data?.error?.code === 11000) {
        toast.error("Invoice with this bill number already exists");
      } else {
        toast.error(
          err?.response?.data?.message ||
          "Something went wrong  while creating invoice"
        );
      }
    }
  };

  const handleViewDetailsClick = (item) => {
    setBillToShow(item);
    setIsShowBill(true);
  };

  const handleCloseBillDetails = () => {
    // setBillToShow(null)
    setIsShowBill(false);
  };

  const updateBillsForPO = (billData) => {
    let localBillsForPO = [...billsForPurchaseOrder];
    let index = localBillsForPO.findIndex((item) => item._id == billData._id);
    localBillsForPO[index] = billData;
    setBillsForPurchaseOrder(localBillsForPO);
  };

  console.log("is Valid User :", isValidUser);
  console.log("Loading :", loading);


  return (
    <div style={{ width: "100%" }}>
      {isValidUser && !loading ? (
        <>
          <Chat RefId={order?.pORefId} open={open} onDrawerClose={onClose} />

          <BillDisplayModal
            show={isShowBill}
            billData={billToShow}
            supplierRFQData={order?.supplierRfqOfferId}
            handleClose={handleCloseBillDetails}
            updateBillsForPO={updateBillsForPO}
            allData={allData}
            masterThreeDTechnologyData={masterThreeDTechnologyData}
            canRemoveImage={canRemoveImage}
            handleRemoveImage={handleRemoveImage}
          />

          <PDFModalViewer
            show={pdfModalInfo.show}
            fileName={pdfModalInfo.fileName}
            pdfUrl={pdfModalInfo.pdfUrl}
            handleClose={() => {
              setPdfModalInfo({
                show: false,
                fileName: '',
                pdfUrl: ''
              }
              )
            }
            }
          />
          <Modal
            size="lg"
            dialogClassName="qoute-version-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showIssueModal}
            onHide={handleIssueModalClose}
          >
            <Modal.Header closeButton>
              <Modal.Title
                id="contained-modal-title-vcenter"
                style={{ fontSize: "15px" }}
              >
                Issue Description
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  handleShowSelectedIssue(k);
                }}
                className="mb-3 qoute-version-tabs"
              >
                {allIssuesForOrder.map((item, i) => {
                  return (
                    <Tab eventKey={i} key={i} title={`Issues ${i + 1}`}></Tab>
                  );
                })}
              </Tabs>
              {Object.keys(orderIssue).length > 0 && (
                <div className="issue-div-admin">
                  <div className="issue-col-admin">
                    <h6>Issue Creation Date :</h6>
                    <p> {moment(orderIssue.createdAt).format("DD MMM YYYY")}</p>
                    <h6>Parts with Issue : </h6>
                    {orderIssue?.partsWithIssue?.length > 0 ? (
                      orderIssue.partsWithIssue.map((orderIssueIn, i) => {
                        return orderIssueIn?.selectedPartFile?.originalname ? (
                          <p
                            className="downloadables"
                            style={{ fontSize: "13px" }}
                            key={i}
                            onClick={async (e) => {
                              const { originalname } = orderIssueIn.selectedPartFile;
                              if (originalname && originalname.endsWith('.pdf')) {
                                const signedUrl = await getPresignedUrlForFile(orderIssueIn.selectedPartFile.bucket, orderIssueIn.selectedPartFile.key);
                                console.log('Signed URL for PDF:', signedUrl);
                                setPdfModalInfo({
                                  show: true,
                                  pdfUrl: signedUrl,
                                  fileName: originalname,
                                })
                                return;
                              }
                              await downloadFileFromS3(orderIssueIn.selectedPartFile);
                            }}
                          >
                            {orderIssueIn?.selectedPartFile?.originalname}
                            <img src={downloadImage} />
                          </p>
                        ) : (
                          <p key={i}>
                            (File Not Available) Item description :{" "}
                            {orderIssueIn.description}{" "}
                          </p>
                        );
                      })
                    ) : (
                      <p>No parts found</p>
                    )}
                  </div>
                  <div className="issue-col-admin">
                    <h6>Purchase Order Related Issues :</h6>
                    <ul>
                      {orderIssue?.orderRelatedIssue?.length > 0 ? (
                        orderIssue.orderRelatedIssue.map((orderIssue, i) => {
                          return <li key={i}>{orderIssue?.name}</li>;
                        })
                      ) : (
                        <li>No Order related issue</li>
                      )}
                    </ul>
                    <h6>Quality Related Issue :</h6>
                    <ul>
                      {orderIssue?.qualityRelatedIssue?.length > 0 ? (
                        orderIssue.qualityRelatedIssue.map((orderIssue, i) => {
                          return <li key={i}>{orderIssue.name}</li>;
                        })
                      ) : (
                        <li>No Quality related issue</li>
                      )}
                    </ul>

                    <h6>Files attached :</h6>
                    <ul style={{ width: "150px", wordBreak: "break-all" }}>
                      {orderIssue?.issueFileAttachment?.length > 0 ? (
                        orderIssue.issueFileAttachment.map(
                          (fileAttached, i) => {
                            return (
                              <li
                                key={i}
                                onClick={async (e) => {
                                  const { originalname } = fileAttached;
                                  if (originalname && originalname.endsWith('.pdf')) {
                                    const signedUrl = await getPresignedUrlForFile(fileAttached.bucket, fileAttached.key);
                                    console.log('Signed URL for PDF:', signedUrl);
                                    setPdfModalInfo({
                                      show: true,
                                      pdfUrl: signedUrl,
                                      fileName: originalname,
                                    })
                                    return;
                                  }
                                  await downloadFileFromS3(fileAttached);
                                }}
                              >
                                <p
                                  className="downloadables"
                                  style={{ fontSize: "13px" }}
                                >
                                  {fileAttached?.originalname}
                                  <img src={downloadImage} />
                                </p>
                              </li>
                            );
                          }
                        )
                      ) : (
                        <li>No files attached</li>
                      )}
                    </ul>
                  </div>

                  <div className="issue-col-admin">
                    <h6>Is Part Issue : </h6>
                    <p>
                      {orderIssue.isPartIssue
                        ? "It is a part related issue"
                        : "Not a part related issue"}
                    </p>
                    <h6>Issue Description :</h6>
                    <div className="item-description">
                      <p>{orderIssue.issueDescription}</p>
                    </div>
                    <h6>Issue status : </h6>
                    {orderIssue.isIssueClosed ? (
                      <span>
                        <p>Closed</p>
                      </span>
                    ) : (
                      <>
                        <span>
                          <p>Open</p>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleIssueModalClose}>Close</Button>
            </Modal.Footer>
          </Modal>
          <Modal
            size="lg"
            dialogClassName="qoute-version-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showExpectedDateModal}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title
                id="contained-modal-title-vcenter"
                // style={{ fontSize: "15px" }}
                className="font-bold"
              >
                {isAcceptPO
                  ? "Please select the expected shipping date (ESD)"
                  : "Change ESD"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ textAlign: "center" }}>
                <div className="flex items-center">
                  <h6 className="font-bold">PSD : </h6>
                  <p className="font-bold mt-2 px-2">
                    {order?.poAcceptanceDate ? (
                      <>
                        {moment(order?.poAcceptanceDate)
                          .add(order?.supplierRfqOfferId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                      </>
                    ) : (
                      <>
                        {moment(Date.now())
                          .add(order?.supplierRfqOfferId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                      </>
                    )}
                  </p>
                </div>
                <h6 className="font-bold">Select ESD : </h6>
                <FormControl
                  type="date"
                  value={
                    expectedShippingDateSelected
                      ? expectedShippingDateSelected
                      : ""
                  }
                  onChange={(e) =>
                    setExpectedShippingDateSelected(e.target.value)
                  }
                  style={{ width: "300px" }}
                />
                <br />
                {!isAcceptPO ||
                  (expectedShippingDateSelected &&
                    moment(Date.now())
                      .add(order?.supplierRfqOfferId?.leadTime, "days")
                      .format("DD MMM YYYY") !=
                    moment(expectedShippingDateSelected).format(
                      "DD MMM YYYY"
                    )) ? (
                  <>
                    <h6 className="font-bold">Reason to change ESD : </h6>
                    <FormControl
                      type="text"
                      value={esdChangeReason}
                      onChange={(e) => setEsdChangeReason(e.target.value)}
                      placeholder="Enter reason to change ESD (100 character max)"
                      maxLength="100"
                    />
                    {isAcceptPO ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        Please provide an explanation for the discrepancy
                        between the expected shipping date (
                        {moment(expectedShippingDateSelected).format(
                          "DD MMM YYYY"
                        )}
                        ) and the promised shipping date(
                        {moment(Date.now())
                          .add(order?.supplierRfqOfferId?.leadTime, "days")
                          .format("DD MMM YYYY")}
                        ).
                      </p>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                {!isAcceptPO && order?.expectedShippingDates?.length > 0 ? (
                  <>
                    <br />
                    <h6>Expected Shipping Date Record : </h6>
                    <div className="parts-table" style={{ fontSize: "14px" }}>
                      <table>
                        <thead>
                          <tr>
                            <th style={{ fontSize: "12px" }}>Updated On</th>
                            <th style={{ fontSize: "12px" }}>
                              Expected Shipping Date
                            </th>
                            <th style={{ fontSize: "12px" }}>
                              Reason To Change
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {order?.expectedShippingDates?.map((item, index) => {
                            return (
                              <tr key={index} style={{ fontSize: "13px" }}>
                                <td>
                                  {moment(item.updatedDate).format(
                                    "DD MMM YYYY h:mm A"
                                  )}
                                </td>
                                <td>
                                  {moment(item.updateValue).format(
                                    "DD MMM YYYY"
                                  )}
                                </td>
                                <td>{item.reasonToChange}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="white-btn"
                style={{
                  backgroundColor: "#2b96dc",
                  color: "#fff",
                  border: "1px solid #2b96dc",
                }}
                onClick={() => {
                  if (isAcceptPO) {
                    handleProceedAcceptPOClick();
                  } else {
                    handleUpdateExpectedShippingDates();
                  }
                }}
              >
                Proceed
              </Button>
              <Button
                className="white-btn"
                style={{
                  backgroundColor: "#2b96dc",
                  color: "#fff",
                  border: "1px solid #2b96dc",
                }}
                onClick={handleClose}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="xl"
            aria-labelledby="example-custom-modal-styling-title"
            centered
            show={showCreateInvoiceModal}
            onHide={closeCreateInvoiceModal}
            style={{
              visibility: !isInvoiceModalVisible ? "hidden" : "visible",
              width: "100vw",
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: "15px" }}>
                Enter invoice details
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <div className="table-container">
                  <table style={{ border: "1px solid gray" }}>
                    <thead>
                      <tr>
                        <th className="px-2 text-start w-40">Snapshot</th>
                        <th className="px-2 text-start w-[200px]">Description</th>
                        <th className="px-2 text-start ">Order Qty</th>
                        <th className="px-2 text-start ">Available Qty</th>
                        <th className="px-2 text-start !w-[130px] ">Invoice Qty</th>
                        <th className="px-2 text-start ">Unit Price</th>
                        <th className="px-2 text-start ">Amount</th>
                      </tr>
                    </thead>
                    <tbody className="invoide-details">
                      {order?.supplierRfqOfferId?.partsData?.length > 0 &&
                        order?.supplierRfqOfferId.partsData.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td >
                                <p className="text-sm bold mt-3 ">
                                  {item?.selectedFile ? <ThreeDViewerComponent
                                    item={item}
                                    selectedProcess={order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess}
                                    additionalClasses={'!border-0'}
                                  /> : null}
                                </p>
                              </td>
                              <td
                                style={{ minWidth: "200px" }}
                                className="!font-normal"

                              >
                                
                                {order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess >= 3 ? (
                                  <>{item.description}</>
                                ) : (
                                  <div className="">
                                    {
                                      order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess == 1 ?
                                        <MetaDataCncComponent allData={allData} item={item} /> : null

                                    }
                                    {
                                      order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess == 2 ?
                                        <MetaDataThreeDComponent masterThreeDTechnologyData={masterThreeDTechnologyData} item={item} /> : null

                                    }

                                  </div>
                                )}
                              </td>
                              <td>
                                <p style={{ textAlign: "center" }}>
                                  {item?.qty}
                                </p>
                              </td>

                              <td>
                                <p style={{ textAlign: "center" }}>
                                  {" "}
                                  {availableQtyArr[item._id]}
                                </p>
                              </td>

                              <td style={{ textAlign: "center" }}>
                                <p>
                                  <input
                                    className="p-1 mx-2 border border-green-500 w-[100px]"
                                    type="text"
                                    value={billPartsData[item._id]}
                                    onWheel={numberInputOnWheelPreventChange}
                                    placeholder="Invoice Qty"
                                    onChange={(e) =>
                                      handeBillItemChange(e, item._id)
                                    }

                                    onKeyDown={(e) =>
                                      ["e", "E", "+", "-"].includes(e.key) &&
                                      e.preventDefault()
                                    }
                                    disabled={!availableQtyArr[item._id]}

                                  />
                                </p>
                              </td>

                              <td>
                                <p className="ms-1">
                                  {" "}

                                  <CurrencyFormat
                                    amount={parseFloat(item?.price).toFixed(2)}
                                  />
                                </p>
                              </td>

                              <td>
                                <div
                                  className=""

                                >
                                  <p className="ms-1">

                                    <CurrencyFormat
                                      amount={parseFloat(
                                        (billPartsData[item._id] || 0) *
                                        item.price
                                      )}
                                    />
                                  </p>
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                      <tr className="heading-row">
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col"></td>
                        <td scope="col" className="mb-2">
                          <p className="ms-1">
                            Total Amount
                          </p>
                        </td>
                        <td scope="col">
                          <p className="un-fld">

                            <CurrencyFormat
                              amount={parseFloat(billTotalAmount).toFixed(2)}
                            />
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="bill-form-container">
                  <div className="bill-form-row">
                    <div>
                      <label htmlFor="invoice-number">Enter Invoice Number:</label>
                      <Form.Control
                        id="invoice-number"
                        type="text"
                        value={supplierBillNumber}
                        placeholder="Enter Invoice Number"
                        onChange={(e) => setSupplierBillNumber(e.target.value)}
                      />
                    </div>

                    <div>
                      <label htmlFor="billShippingDate">
                        Enter Shipping Date:
                      </label>
                      <Form.Control
                        id="billShippingDate"
                        type="date"
                        value={billShippingDate}
                        placeholder="Enter shipping date"
                        onChange={(e) => {

                          setBillShippingDate(e.target.value);
                        }}
                      />
                    </div>

                    <div>
                      <label htmlFor="billShippingCarrier">
                        Enter Shipping Carrier:
                      </label>
                      <Form.Control
                        id="billShippingCarrier"
                        type="text"
                        value={billShippingCarrier}
                        placeholder="Enter shipping carrier"
                        onChange={(e) => setBillShippingCarrier(e.target.value)}
                      />
                    </div>

                    <div>
                      <label htmlFor="billTrackingNumber">
                        Enter Tracking Number:
                      </label>
                      <Form.Control
                        id="billTrackingNumber"
                        type="text"
                        value={billTrackingNumber}
                        placeholder="Enter Tracking Number"
                        onChange={(e) => setBillTrackingNumber(e.target.value)}
                      />
                    </div>

                    <div>
                      <label htmlFor="billDocument">Invoice Document:</label>
                      <br />
                      {billDocument?.name ? (
                        <span className="flex items-center space-x-2">
                          <a
                            className="downloadables inline-flex items-center space-x-1"
                            href={URL.createObjectURL(billDocument)}
                            download={billDocument?.filename}
                            target="_blank"
                            style={{ fontSize: "12px" }}
                          >
                            {billDocument?.name}
                            <DownloadIcon additionalClass="inline-block mx-1 !h-5" />
                          </a>
                          <span
                            className="inline-flex items-center"
                            onClick={() => setBillDocument(null)}
                          >
                            <DeleteIcon additionalClasses="inline-block" />
                          </span>
                        </span>
                      ) : (
                        <>
                          <WithDragAndDrop
                            additionalClassNames="w-full"
                            onFilesSelected={(e) => {
                              let filesForCheck = Array.from(e.target.files);
                              let isAllFilesValid = true;
                              filesForCheck.forEach((file) => {
                                if (file.size > MAX_FILE_LIMIT) {
                                  isAllFilesValid = false;
                                }
                              });
                              if (!isAllFilesValid) {
                                toast.error(
                                  "File size should be less than 100 MB"
                                );
                                return;
                              }
                              setBillDocument(e.target.files[0]);
                            }}
                          >
                            <label
                              className="bill-button"
                              htmlFor={`upload-bill-doc`}
                            >
                              Upload Invoice Document
                            </label>
                            <Form.Control
                              id={`upload-bill-doc`}
                              type="file"
                              style={{ visibility: "hidden" }}
                              onChange={(e) => {
                                let filesForCheck = Array.from(e.target.files);
                                let isAllFilesValid = true;
                                filesForCheck.forEach((file) => {
                                  if (file.size > MAX_FILE_LIMIT) {
                                    isAllFilesValid = false;
                                  }
                                });

                                if (!isAllFilesValid) {
                                  toast.error(
                                    "File size should be less than 100 MB"
                                  );
                                  return;
                                }
                                setBillDocument(e.target.files[0]);
                              }}
                            />
                          </WithDragAndDrop>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="bill-form-container">
                    <div className="h-20 " >
                      <div>
                        <label htmlFor="billDate" className=" font-bold text-[13px] text-[#858585] " style={{ color: "" }}>Consignment Photos:</label>
                        <div>
                          <input
                            type="checkbox"
                            checked={isNoConsignments}
                            onChange={() =>
                              setIsNoConsignments(!isNoConsignments)
                            }
                            id="consign-check"
                          />
                          <label
                            htmlFor="consign-check"
                            className="check-label text-red-500 font-bold text-[12px]"

                          >
                            Please check this box to confirm that there are no
                            consignment photos to be uploaded with this
                            invoice.Note that incorrect selection might lead to
                            invoice rejection.
                          </label>
                        </div>

                        {!isNoConsignments &&
                          <WithDragAndDrop
                            additionalClassNames="w-40"
                            onFilesSelected={(e) => {
                              let filesForCheck = Array.from(e.target.files);
                              let isAllFilesValid = true;
                              filesForCheck.forEach((file) => {
                                if (file.size > MAX_FILE_LIMIT) {
                                  isAllFilesValid = false;
                                }
                              });

                              if (!isAllFilesValid) {
                                toast.error(
                                  "File size should be less than 100 MB"
                                );
                                return;
                              }
                              handleConsignmentPhotosUpload(e);
                            }}

                          >
                            <label

                              className=" py-1  font-bold text-[12px] border-[1px] rounded border-[#b4b4b4] mt-1 w-40  px-2.5  flex justify-center text-primaryColor"
                              htmlFor={`upload-bill-conginments-photos`}
                            >
                              Upload
                            </label></WithDragAndDrop>}
                        {!isNoConsignments && <Form.Control
                          id={`upload-bill-conginments-photos`}
                          type="file"
                          style={{ visibility: "hidden" }}
                          multiple={true}
                          onChange={(e) => {
                            let filesForCheck = Array.from(e.target.files);
                            let isAllFilesValid = true;
                            filesForCheck.forEach((file) => {
                              if (file.size > MAX_FILE_LIMIT) {
                                isAllFilesValid = false;
                              }
                            });

                            if (!isAllFilesValid) {
                              toast.error(
                                "File size should be less than 100 MB"
                              );
                              return;
                            }
                            handleConsignmentPhotosUpload(e);
                          }}
                          accept="image/*"
                        />}
                      </div>
                    </div>

                    {billConsignmentPhotos && !isNoConsignments &&
                      billConsignmentPhotos.length > 0 ? (
                      <div >
                        <span>
                          <ConsignmentPhotoViewer
                            parentModalVisibilityFunction={
                              setInvoiceModalVisible
                            }
                            canRemoveImage={canRemoveImage}
                            handleRemoveImage={handleRemoveImage}
                            images={billConsignmentPhotos || []}
                            altText={`image`}
                          />
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div className="bill-form-row">
                    <div className="!mx-0 !px-0">
                      <label htmlFor="dueDate" className=" font-bold text-[13px] text-[#858585] " >Quality Documents:</label>
                      <div className="flex justify-start items-center border-red-500 !mx-0 !px-0 !my-0 !py-0 ">
                        <input
                          type="checkbox"
                          checked={isNoQCDoc}
                          onChange={() => setIsNoQCDoc(!isNoQCDoc)}
                          id="quality-check"
                        />
                        <label htmlFor="quality-check" className="check-label whitespace-nowrap text-red-500 font-bold text-[12px]">
                          Please check this box to confirm that there are
                          no quality document to be uploaded with this
                          invoice.Note that incorrect selection might lead
                          to invoice rejection.
                        </label>
                      </div>
                      {!isNoQCDoc && <label >Document Name:</label>}
                      {!isNoQCDoc && <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* <div className="col   "> */}
                        {/* <div className=" w-[200px] !me-3"> */}
                        <Form.Control
                          className="border h-8  w-full  "
                          type="text"
                          name="document-name"
                          placeholder="Enter document name here"
                          value={qualityDocObject.name || ""}
                          // style={{ marginLeft: "-5px" }}/
                          onChange={(e) =>
                            setQualityDocObject({
                              ...qualityDocObject,
                              name: e.target.value,
                            })
                          }
                        />
                        {/* </div> */}
                        {/* </div> */}
                        <WithDragAndDrop
                          disabled={!(!(
                            qualityDocObject?.file?.filename ||
                            qualityDocObject?.file?.name
                          ) &&
                            qualityDocObject.name)}
                          additionalClassNames="w-40 h-9"
                          onFilesSelected={(e) => {
                            let filesForCheck = Array.from(
                              e.target.files
                            );
                            let isAllFilesValid = true;
                            filesForCheck.forEach((file) => {
                              if (file.size > MAX_FILE_LIMIT) {
                                isAllFilesValid = false;
                              }
                            });

                            if (!isAllFilesValid) {
                              toast.error(
                                "File size should be less than 100 MB"
                              );
                              return;
                            }

                            setQualityDocObject({
                              ...qualityDocObject,
                              file: e.target.files[0],
                            });
                            const file = e.target.files[0];
                            if (!qualityDocObject.name || !file) {
                              toast.error(
                                "Document name and file are required."
                              );
                              return;
                            }

                            setBillQualityDocuments([
                              ...billQualityDocuments,
                              { ...qualityDocObject, file },
                            ]);
                            setQualityDocObject({
                              name: "",
                            });
                          }}
                        >
                          <div className="col quality-doc-div-po">
                            {!(
                              qualityDocObject?.file?.filename ||
                              qualityDocObject?.file?.name
                            ) &&
                              qualityDocObject.name && (

                                <div>
                                  <label
                                    className="bill-button"
                                    htmlFor={`uploadDoc`}
                                  >
                                    Upload
                                  </label>
                                  <Form.Control
                                    id={`uploadDoc`}
                                    className="quality-doc-item-input"
                                    type="file"
                                    onChange={(e) => {
                                      let filesForCheck = Array.from(
                                        e.target.files
                                      );
                                      let isAllFilesValid = true;
                                      filesForCheck.forEach((file) => {
                                        if (file.size > MAX_FILE_LIMIT) {
                                          isAllFilesValid = false;
                                        }
                                      });

                                      if (!isAllFilesValid) {
                                        toast.error(
                                          "File size should be less than 100 MB"
                                        );
                                        return;
                                      }

                                      setQualityDocObject({
                                        ...qualityDocObject,
                                        file: e.target.files[0],
                                      });
                                      const file = e.target.files[0];
                                      if (!qualityDocObject.name || !file) {
                                        toast.error(
                                          "Document name and file are required."
                                        );
                                        return;
                                      }

                                      setBillQualityDocuments([
                                        ...billQualityDocuments,
                                        { ...qualityDocObject, file },
                                      ]);
                                      setQualityDocObject({
                                        name: "",
                                      });
                                    }}
                                    accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                  />
                                </div>
                              )}
                          </div>
                        </WithDragAndDrop>
                      </div>

                      }


                      {billQualityDocuments?.length > 0 ? (
                        <>

                          {billQualityDocuments.map((item, i) => {
                            return (
                              <div
                                className="singleAddress  "
                                key={i}
                                style={{
                                  marginTop: "5px",
                                }}
                              >

                                <div className="address">
                                  <div className="name text-sm font-semibold text-[#858585]">
                                    Document Name : {item.name}
                                  </div>
                                  <div className="add flex items-center gap-x-2 ">
                                    <span className="text-[#858585]">File :</span>
                                    {item.file?.filename ? (
                                      <div>
                                        <a
                                          className="downloadables flex items-center gap-x-2"
                                          href={
                                            item.file?.name
                                              ? URL.createObjectURL(
                                                item.file
                                              )
                                              : (item.file
                                                ?.originalname,
                                                `${process.env.REACT_APP_API_ENDPOINT}/${item.file?.path}`)
                                          }
                                          download={
                                            item.file?.filename
                                          }
                                          target="_blank"
                                        >
                                          <span>
                                            {
                                              item.file
                                                ?.originalname
                                            }
                                          </span>
                                          <DownloadIcon />
                                        </a>
                                      </div>
                                    ) : (
                                      <div className="flex items-center gap-x-2 ">
                                        <a
                                          className="text-primaryColor  flex items-center gap-x-2 "
                                          href={
                                            item.file?.name
                                              ? URL.createObjectURL(
                                                item.file
                                              )
                                              : (item.file
                                                ?.originalname,
                                                `${process.env.REACT_APP_API_ENDPOINT}/${item.file?.path}`)
                                          }
                                          download={
                                            item.file?.filename
                                          }
                                          target="_blank"
                                        >
                                          {item.file?.name}
                                          <DownloadIcon />
                                        </a>
                                        <div
                                          onClick={() =>
                                            handleQualityDocumentDelete(
                                              i
                                            )
                                          }
                                        >
                                          <DeleteIcon />
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                            );
                          })}

                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <>
                <button className="req-quote-btn" onClick={handleCreateBill}>
                  Send For Approval
                </button>
              </>
              <button
                className="req-quote-btn"
                onClick={closeCreateInvoiceModal}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

          <div className="intro-bar-rfq">
            <div className="int-left">
              <div
                className="left-item"
                style={{ marginRight: "20px", cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                <img src={backImg} height="15px" />
              </div>
              <div className="left-item">
                <p className="p-header">ORDER ID : {order?.pORefId}</p>
                <p className={`${order?.status?.replaceAll(" ", "_")}  flex items-center justify-center my-1 ${billsForPurchaseOrder.length > 0 && order?.status == 'Order Processing' && "Partially_Billed"}`}>
                  {billsForPurchaseOrder.length > 0 && order?.status == 'Order Processing' ? "Partially billed" : order?.status}
                </p>
              </div>
              <div className="left-item">
                <p className="p-header">REQUESTED DATE</p>
                <p>
                  {moment(order?.poApprovedDate || order?.createdAt).format(
                    "DD MMM YYYY"
                  )}
                </p>
              </div>
              <div className="left-item">
                <p className="p-header">ORDER VALUE</p>
                <p>

                  <CurrencyFormat
                    amount={parseFloat(order?.totalAmount).toFixed(2)}
                  />
                </p>
              </div>
              <div className="left-item flex flex-col items-start gap-x-2">
                <span className="p-header flex">
                  <span className="mx-1">PSD</span>
                  <HoverInfo content="Promised Shipping Date(PSD) : If you require extension due to any unforeseen circumstance please get in touch with support team at admin" />
                </span>
                <p className="font-bold">
                  {order?.poAcceptanceDate ? (
                    <>
                      {moment(order?.poAcceptanceDate)
                        .add(order?.supplierRfqOfferId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                    </>
                  ) : (
                    <>
                      {moment(Date.now())
                        .add(order?.supplierRfqOfferId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                    </>
                  )}
                </p>
              </div>
              <div className="left-item flex flex-col items-start gap-x-2" >
                <span className="p-header">
                  <div className="flex gap-x-2 items-center">
                    <span className="flex">
                      <span className="">ESD</span>
                      <HoverInfo content="Expected Shipping Date. In case of delivery delay, click on edit icon on the right to change the expected shipping date." />
                    </span>

                  </div>
                </span>
                <p className="font-bold flex items-center  gap-x-1 ">
                  {order?.expectedShippingDates?.length > 0 ? (
                    <>
                      {moment(
                        order?.expectedShippingDates.reduce(
                          (maxObj, currentObj) => {
                            if (currentObj.updatedDate > maxObj.updatedDate) {
                              return currentObj;
                            }
                            return maxObj;
                          }
                        ).updateValue
                      ).format("DD MMM YYYY")}
                    </>
                  ) : (
                    <>
                      {moment(order?.poAcceptanceDate)
                        .add(order?.supplierRfqOfferId?.leadTime, "days")
                        .format("DD MMM YYYY")}
                    </>
                  )}
                  {billsForPurchaseOrder?.length == 0 && (
                    <div onClick={() => setShowExpectedDateModal(true)}>
                      <EditIcon additionalClass={'text-primaryColor !h-4 mt-[2px]'} />
                    </div>
                  )}
                </p>

              </div>
            </div>
            <div className="int-right">
              {order?.status == "Awaiting PO Acceptance" ? <div className="right-item">
                <button
                  className="white-btn"
                  onClick={handlePODownloadClick}
                  style={{ fontWeight: "500" }}
                >
                  {" "}
                  <DownloadIcon additionalClass={'!h-4'} />
                  &nbsp; Download PO
                </button>
              </div> : null}
              <div className="right-item">
                <button
                  className="border bg-primaryColor rounded"
                  onClick={showDrawer}
                >
                  <ChatButton
                    color={"white"}
                    RefId={order?.pORefId}
                    showDrawer={showDrawer}
                  />
                </button>
              </div>
            </div>
          </div>

          <div className="dashboard-holder">
            <div className="md-container">
              <div className="common-bx">
                <div
                  className={
                    order?.status == "Awaiting PO Acceptance"
                      ? "process-bar-bx upload-req or-details-row"
                      : "process-bar-bx  upload-req green-line or-details-row"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={settingw} />
                  </span>
                  <div className="req-box">

                    <Accordion
                      expanded={expanded === "panel1"}
                      onChange={handleChange("panel1")}
                      className="requirement-box"
                    >
                      <AccordionSummary
                        // expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <div className="accordion-title">
                          <div className="accordion-icon">
                            <span
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                width: "100%",
                                justifyContent: "space-between",
                              }}
                            >
                              <span>
                                <h5>Order Details</h5>
                                <div className="cnc-box">
                                  <p>
                                    Order placed on{" "}
                                    {moment(
                                      order?.supplierRfqOfferId?.createdAt
                                    ).format("DD MMM YYYY")}
                                  </p>
                                  <div className="cnc-box">
                                    {processType.map((val, i) => {
                                      if (
                                        val.id ==
                                        order?.supplierRfqOfferId?.selectedProcess
                                      ) {
                                        return <p key={i}>{val.name}</p>;
                                      } else {
                                        return;
                                      }
                                    })}
                                  </div>
                                </div>
                              </span>
                              <div style={{ marginRight: "30px" }}>
                                <span
                                  className="text"
                                  style={{ color: "#858585" }}
                                >
                                  Project Name
                                </span>
                                <div className="name">
                                  {order?.supplierRfqOfferId?.rfqOfferId?.projectName ||
                                    "Not Found"}
                                </div>
                              </div>
                            </span>

                            <img
                              src={
                                expanded === "panel1"
                                  ? upArrowIcon
                                  : downArrowIcon
                              }
                              alt="arrowIcon"
                              style={{ height: "8px", marginRight: "10px" }}
                            />
                          </div>
                        </div>
                      </AccordionSummary>

                      <AccordionDetails >
                        {order?.supplierRfqOfferId ? (
                          <div className="version-tabs " >
                            {order?.status == "Awaiting PO Acceptance" ? (
                              <>
                                <div
                                  style={{
                                    background: "#FFF5C4",
                                    padding: "20px 30px",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                  className="mx-7"
                                >
                                  <div>
                                    <h6>
                                      Quote accepted. Awaiting PO acceptance.
                                    </h6>
                                    <p>
                                      Please accept the PO to confirm the
                                      order?.
                                    </p>
                                  </div>
                                  <div className="flex justify-between gap-x-2 items-center">
                                    <button
                                      className="flex items-center justify-center gap-x-2  w-[180px] h-10 rounded"
                                      style={{
                                        color: "white",
                                        fontWeight: "500",
                                        backgroundColor: "#00c389",

                                      }}
                                      onClick={handleAcceptPOClick}
                                    >
                                      Accept PO
                                    </button>

                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="pro-bar">
                                <div className="pro-text">
                                  <div className="pro-bar-two">
                                    <div
                                      className="col"
                                    >
                                      <h6>ORDER ACCEPTED ON:</h6>
                                      <div className="desc-part">
                                        <p>
                                          {moment(
                                            order?.poAcceptanceDate
                                          ).format("DD MMM YYYY")}
                                        </p>
                                      </div>
                                    </div>

                                    <div
                                      className="col"
                                    >
                                      <h6>PO NUMBER :</h6>
                                      <div className="desc-part">
                                        <p>
                                          {order?.purchaseOrderNumber
                                            ? order?.purchaseOrderNumber
                                            : "NA"}
                                        </p>
                                      </div>
                                    </div>
                                    {<div
                                      className="col"
                                    >
                                      <h6>PO Document</h6>
                                      <button
                                        className="white-btn"
                                        onClick={handlePODownloadClick}
                                        style={{
                                          fontWeight: "500",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <DownloadIcon additionalClass={'!h-4'} />
                                        <span>Download PO</span>
                                      </button>
                                    </div>}
                                    <div
                                      className="col"
                                    >
                                      <h6>SHIPPING ADDRESS</h6>
                                      <div className="desc-part">
                                        <p>
                                          {order?.shippingAddress?.firstName
                                            ? order?.shippingAddress?.firstName
                                            : "" +
                                              " " +
                                              order?.shippingAddress?.lastName
                                              ? order?.shippingAddress?.lastName
                                              : ""}{" "}
                                        </p>
                                        <p>
                                          {order?.shippingAddress
                                            ?.addressLineOne
                                            ? order?.shippingAddress
                                              ?.addressLineOne
                                            : "" +
                                              " " +
                                              order?.shippingAddress
                                                ?.addressLineTwo
                                              ? order?.shippingAddress
                                                ?.addressLineTwo
                                              : ""}
                                        </p>
                                        <p>
                                          {order?.shippingAddress?.city
                                            ? order?.shippingAddress?.city
                                            : "" +
                                              ", " +
                                              order?.shippingAddress?.state
                                              ? order?.shippingAddress?.state
                                              : "" +
                                                ", " +
                                                order?.shippingAddress?.country
                                                ? order?.shippingAddress?.country
                                                : ""}
                                        </p>
                                        <p>
                                          {order?.shippingAddress?.postalCode
                                            ? order?.shippingAddress?.postalCode
                                            : ""}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}


                            <br />
                            <Tabs
                              id="controlled-tab-example"
                              activeKey={"final-order"}
                              className="mb-3 qoute-version-tabs"
                            >
                              <Tab eventKey="final-order" title={`Final Order`}>
                                <div
                                  className="version-tabs overflow-x-auto"
                                >
                                  <table className="qoute-version-table ">
                                    <thead>
                                      <tr className="heading-row">
                                        <th scope="col">Snapshot</th>
                                        <th scope="col">Files</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Notes</th>
                                        <th scope="col">Unit Price</th>
                                        <th scope="col">Qty</th>
                                        <th scope="col">Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {order?.supplierRfqOfferId?.partsData?.length >
                                        0 &&
                                        order?.supplierRfqOfferId.partsData.map(
                                          (item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td
                                                  style={{ minWidth: "150px" }}
                                                >
                                                  <p className="text-sm bold  flex items-center justify-center
                                                  ">
                                                    <ThreeDViewerComponent
                                                      item={item}
                                                      selectedProcess={order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess}
                                                      additionalClasses={'!border-0'}
                                                    />
                                                  </p>
                                                </td>
                                                <td
                                                  style={{ minWidth: "250px" }}
                                                >
                                                  <p className="!text-primaryColor">
                                                    {item.selectedFile?.originalname ? (
                                                      <>

                                                        <FileName
                                                          fileName={item.selectedFile?.originalname}
                                                          onDownload={async () => {
                                                            const { originalname } = item?.selectedFile;
                                                            if (originalname && originalname.endsWith('.pdf')) {
                                                              const signedUrl = await getPresignedUrlForFile(item?.selectedFile.bucket, item?.selectedFile.key);
                                                              console.log('Signed URL for PDF:', signedUrl);
                                                              setPdfModalInfo({
                                                                show: true,
                                                                pdfUrl: signedUrl,
                                                                fileName: originalname,
                                                              })
                                                              return;
                                                            }
                                                            await downloadFileFromS3(item?.selectedFile)

                                                          }}
                                                        />


                                                        <DimensionsDisplay
                                                          item={item}
                                                        />
                                                      </>
                                                    ) : (
                                                      "File Not Available"
                                                    )}
                                                  </p>
                                                  <p className="!text-primaryColor">
                                                    {item.twoDFile?.originalname ? (
                                                      <>
                                                        <div className="inline-block">
                                                          <FileName
                                                            fileName={item.twoDFile?.originalname}
                                                            onDownload={async () => {
                                                              const { originalname } = item?.twoDFile;
                                                              if (originalname && originalname.endsWith('.pdf')) {
                                                                const signedUrl = await getPresignedUrlForFile(item?.twoDFile.bucket, item?.twoDFile.key);
                                                                console.log('Signed URL for PDF:', signedUrl);
                                                                setPdfModalInfo({
                                                                  show: true,
                                                                  pdfUrl: signedUrl,
                                                                  fileName: originalname,
                                                                })
                                                                return;
                                                              }
                                                              await downloadFileFromS3(item?.twoDFile)

                                                            }}
                                                          />

                                                        </div>
                                                        <DimensionsDisplay
                                                          item={item}
                                                        />
                                                      </>
                                                    ) : (
                                                      "File Not Available"
                                                    )}
                                                  </p>
                                                </td>

                                                <td style={{ minWidth: "250px" }}>
                                                  {order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess >= 3 ? (
                                                    <>{item.description}</>
                                                  ) : (
                                                    <div>
                                                      {
                                                        order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess == 1 ?
                                                          <MetaDataCncComponent allData={allData} item={item} /> : null

                                                      }
                                                      {
                                                        order?.supplierRfqOfferId?.rfqOfferId?.selectedProcess == 2 ?
                                                          <MetaDataThreeDComponent masterThreeDTechnologyData={masterThreeDTechnologyData} item={item} /> : null

                                                      }

                                                    </div>
                                                  )}
                                                </td>
                                                <td style={{ minWidth: "200px" }}>
                                                  <p className="amt">
                                                    {item?.notes}
                                                  </p>
                                                </td>
                                                <td style={{ minWidth: "100px" }}>
                                                  <p className="amt">
                                                    {" "}

                                                    <CurrencyFormat
                                                      amount={parseFloat(
                                                        item?.price
                                                      ).toFixed(2)}
                                                    />
                                                  </p>
                                                </td>
                                                <td style={{ minWidth: "70px" }}>
                                                  <p className="amt text-center">
                                                    {item?.qty}
                                                  </p>{" "}
                                                </td>
                                                <td>
                                                  {" "}
                                                  <div
                                                    className="amt"
                                                    style={{ width: "60px" }}
                                                  >
                                                    <p className="un-fld">

                                                      <CurrencyFormat
                                                        amount={parseFloat(
                                                          item.qty * item.price
                                                        ).toFixed(2)}
                                                      />
                                                    </p>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}

                                      {order.adjustmentValue != 0 ? (
                                        <>
                                          <tr className="heading-row">
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col">Adjustments</td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col"></td>
                                            <td scope="col">
                                              <p className="un-fld">

                                                <CurrencyFormat
                                                  amount={Number(
                                                    order.adjustmentValue
                                                  ).toFixed(2)}
                                                />
                                              </p>
                                            </td>
                                          </tr>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Tab>
                            </Tabs>
                          </div>
                        ) : (
                          <>
                            <p>Loading</p>
                          </>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>

                {/* <div
                  className={
                    order?.status == "Awaiting PO Acceptance"
                      ? "process-bar-bx upload-req or-details-row"
                      : "process-bar-bx  upload-req green-line or-details-row"
                  }
                >
                  <span className="process-ico green-fill">
                    <img src={orderIcon} />
                  </span>
                  <Accordion
                    expanded={expanded === "panel2"}
                    onChange={handleChange("panel2")}
                  >
                    <AccordionSummary
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                    >
                      <div style={{ marginTop: "-10px" }}>
                        <div className="accordion-icon">
                          <h5>Order Details</h5>
                          <img
                            src={
                              expanded === "panel2"
                                ? upArrowIcon
                                : downArrowIcon
                            }
                            alt="arrowIcon"
                            style={{ height: "8px", marginRight: "10px" }}
                          />
                        </div>
                        <div className="orderAndPayment">
                          <p>
                            Order placed on{" "}
                            {moment(order?.createdAt).format("DD MMM YYYY")}
                          </p>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      {order?.status == "Awaiting PO Acceptance" ? (
                        <>
                          <div
                            style={{
                              background: "#FFF5C4",
                              padding: "20px 30px",
                              borderRadius: "5px",
                              fontSize: "14px",
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <h6>Quote accepted. Awaiting PO acceptance.</h6>
                              <p>Please accept the PO to confirm the order?.</p>
                            </div>
                            <div>
                              <button
                                className="chatButton"
                                style={{
                                  color: "white",
                                  fontWeight: "500",
                                  backgroundColor: "#00c389",
                                  width: "150px",
                                  marginBottom: "5px",
                                }}
                                onClick={handleAcceptPOClick}
                              >
                                Accept PO
                              </button>

                              <button
                                className="white-btn"
                                onClick={handlePODownloadClick}
                                style={{
                                  fontWeight: "500",
                                  marginRight: "0px",
                                  width: "150px",
                                }}
                              >
                                <img src={downloadImage} height="12" />
                                &nbsp; Download PO
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="pro-bar">
                          <div className="pro-text">
                            <div className="pro-bar-one"></div>
                            <div className="pro-bar-two">
                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>ORDER ACCEPTED ON:</h6>
                                <div className="desc-part">
                                  <p>
                                    {moment(order?.poAcceptanceDate).format(
                                      "DD MMM YYYY"
                                    )}
                                  </p>
                                </div>
                              </div>

                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>PO NUMBER :</h6>
                                <div className="desc-part">
                                  <p>
                                    {order?.purchaseOrderNumber
                                      ? order?.purchaseOrderNumber
                                      : "NA"}
                                  </p>
                                </div>
                              </div>
                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>PO Document</h6>
                                <button
                                  className="white-btn"
                                  onClick={handlePODownloadClick}
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "12px",
                                  }}
                                >
                                  {" "}
                                  <img
                                    src={downloadImage}
                                    alt="download-img"
                                    height="12"
                                  />
                                  &nbsp; Download PO
                                </button>
                              </div>
                              <div
                                className="col"
                                style={{ marginTop: "10px" }}
                              >
                                <h6>SHIPPING ADDRESS</h6>
                                <div className="desc-part">
                                  <p>
                                    {order?.shippingAddress?.firstName
                                      ? order?.shippingAddress?.firstName
                                      : "" +
                                        " " +
                                        order?.shippingAddress?.lastName
                                        ? order?.shippingAddress?.lastName
                                        : ""}{" "}
                                  </p>
                                  <p>
                                    {order?.shippingAddress?.addressLineOne
                                      ? order?.shippingAddress?.addressLineOne
                                      : "" +
                                        " " +
                                        order?.shippingAddress?.addressLineTwo
                                        ? order?.shippingAddress?.addressLineTwo
                                        : ""}
                                  </p>
                                  <p>
                                    {order?.shippingAddress?.city
                                      ? order?.shippingAddress?.city
                                      : "" +
                                        ", " +
                                        order?.shippingAddress?.state
                                        ? order?.shippingAddress?.state
                                        : "" +
                                          ", " +
                                          order?.shippingAddress?.country
                                          ? order?.shippingAddress?.country
                                          : ""}
                                  </p>
                                  <p>
                                    {order?.shippingAddress?.postalCode
                                      ? order?.shippingAddress?.postalCode
                                      : ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </AccordionDetails>
                  </Accordion>
                </div> */}

                {order?.status == "Awaiting PO Acceptance" ? (
                  <></>
                ) : (
                  <>
                    {order?.qrCodeDrawingFile?.originalname ? (
                      <>
                        <div
                          className={
                            order?.qrCodeDrawingFile?.originalname
                              ? "process-bar-bx upload-req or-details-row grey-line"
                              : "process-bar-bx upload-req or-details-row green-line"
                          }
                        >
                          <span
                            className={
                              order?.qrCodeDrawingFile.originalname
                                ? "process-ico green-fill"
                                : "process-ico grey-fill"
                            }
                          >
                            <img src={qrCodeIcon} />
                          </span>
                          <Accordion
                            expanded={expanded === "panel3"}
                            onChange={handleChange("panel3")}
                          >
                            <AccordionSummary
                              aria-controls="panel3bh-content"
                              id="panel3bh-header"
                            >
                              <div style={{ marginTop: "-10px" }}>
                                <div className="accordion-icon">
                                  <h5>QR Code</h5>
                                  <img
                                    src={
                                      expanded === "panel3"
                                        ? upArrowIcon
                                        : downArrowIcon
                                    }
                                    alt="arrowIcon"
                                    style={{
                                      height: "8px",
                                      marginRight: "10px",
                                    }}
                                  />
                                </div>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <div className="pro-bar">
                                <div className="pro-text">
                                  <div className="pro-bar-one"></div>
                                  <div className="pro-bar-two">
                                    <div
                                      className="col"
                                      style={{ marginTop: "10px" }}
                                    >
                                      <div>
                                        <p>
                                          The customer has made a request to
                                          have QR codes etched onto the parts.
                                        </p>
                                      </div>
                                      <br />
                                      <div>
                                        <button
                                          className="white-btn"
                                          onClick={async () => {
                                            const { originalname } = order?.qrCodeDrawingFile;
                                            if (originalname && originalname.endsWith('.pdf')) {
                                              const signedUrl = await getPresignedUrlForFile(order?.qrCodeDrawingFile.bucket, order?.qrCodeDrawingFile.key);
                                              console.log('Signed URL for PDF:', signedUrl);
                                              setPdfModalInfo({
                                                show: true,
                                                pdfUrl: signedUrl,
                                                fileName: originalname,
                                              })
                                              return;
                                            }
                                            downloadFileFromS3(order?.qrCodeDrawingFile)
                                          }
                                          }
                                          style={{
                                            fontWeight: "500",
                                            fontSize: "13px",
                                          }}
                                        >
                                          <img
                                            src={downloadImage}
                                            alt="download-img"
                                            height="13"
                                          />
                                          &nbsp; Download QR Drawing File
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <div
                      className={
                        order?.status == "Order Processing"
                          ? "process-bar-bx upload-req or-details-row"
                          : "process-bar-bx upload-req or-details-row"
                      }
                    >
                      <span
                        className={
                          billsForPurchaseOrder.length > 0
                            ? "process-ico green-fill"
                            : "process-ico grey-fill"
                        }
                      >
                        <img src={consignmentPhotoIcon} />
                      </span>
                      <Accordion
                        expanded={expanded === "panel4"}
                        onChange={handleChange("panel4")}
                      >
                        <AccordionSummary
                          aria-controls="panel4bh-content"
                          id="panel4bh-header"
                        >
                          <div style={{ marginTop: "-10px" }}>
                            <div className="accordion-title">
                              <div className="accordion-icon">
                                <h5>Invoicing</h5>
                                <img
                                  src={
                                    expanded === "panel4"
                                      ? upArrowIcon
                                      : downArrowIcon
                                  }
                                  alt="arrowIcon"
                                  style={{ height: "8px", marginRight: "10px" }}
                                />
                              </div>
                            </div>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className="pro-bar">
                            <div
                              style={{
                                width: "100%",
                                textAlign: "right",
                                marginBottom: "10px",
                              }}
                            >
                              {order?.status != "Cancelled" ? <button
                                className="white-btn"
                                onClick={handleCreateNewInvoiceClick}
                              >
                                <DownloadIcon additionalClass={'!h-4'} />

                                <span className="text-primaryColor mx-2 font-medium">Create New Invoice</span>
                              </button> : null}
                            </div>
                            <div className="pro-bar-two">
                              <div className="table-container">
                                <table>
                                  <thead>
                                    <tr>
                                      <th>Invoice Ref</th>
                                      <th>Invoice Number</th>
                                      <th>Amount</th>
                                      <th>Status</th>
                                      <th>Sent Date</th>
                                      <th>Shipping Date</th>
                                      <th>Due Date</th>
                                      {/* <th>Details</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {billsForPurchaseOrder.length > 0 ? (
                                      billsForPurchaseOrder?.map(
                                        (item, index) => {
                                          return (
                                            <tr key={index}>
                                              <td
                                                onClick={() =>
                                                  handleViewDetailsClick(item)
                                                }>
                                                <Link className="underline text-primaryColor">{item.billNumber}</Link>
                                              </td>
                                              <td>{item.supplierBillNumber}</td>
                                              <td>
                                                <CurrencyFormat
                                                  amount={item.billTotalAmount}
                                                />
                                              </td>
                                              <td>{item.status.replace(/_/g, ' ').replace(/\b\w/, (c) => c.toUpperCase())}</td>

                                              <td>
                                                {moment(item.createdAt).format(
                                                  "DD MMM YYYY"
                                                )}
                                              </td>

                                              <td>
                                                {moment(
                                                  item.shippedDate
                                                ).format("DD MMM YYYY")}
                                              </td>
                                              <td>
                                                {item.dueDate
                                                  ? moment(
                                                    item.shippedDate
                                                  ).format("DD MMM YYYY")
                                                  : "NA"}
                                              </td>

                                            </tr>
                                          );
                                        }
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </tbody>
                                </table>
                                {billsForPurchaseOrder.length == 0 ? (
                                  <>
                                    <p
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {" "}
                                      No Invoice is created for purchase order.
                                      Please create invoice using "Create New
                                      Invoice" button.
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      ) : loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <div className="dashboard-holder">
            <div className="sm-container">
              <div className="dashboard-option">
                <div className="dash-left">
                  <div className="ds-heading">
                    <Link to="/dashboard">
                      <p className="req-quote-btn">Go To DashBoard </p>
                    </Link>
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                  <h2>Order information is not available</h2>
                  <br />
                  <p>Your dont have access to this order details.</p>
                </div>
              </div>

            </div>
          </div>
        </>
      )
      }
    </div >
  );
};
export default OrderDetails;
